module.exports = __webpack_public_path__ + "static/sacrum-aba7e24f15bdf5e203207a9518c76e65.jpg";